module.exports = __webpack_public_path__ + "img/43-qhjtzyjs.a194f7ba.png";